(ns practitest.frontend.sections 
  (:require    [practitest.frontend.pt-ts-bridge :refer [FormLayoutWrapper, TranslationProvider]]
               [cljs.core :refer [clj->js]]
               [practitest.frontend.components2.spinners :refer [mux-spinner]]
               [practitest.frontend.routing.router :as router]
               [practitest.frontend.sections.events :as section]
               [practitest.frontend.events :as events]
               [practitest.frontend.subs :as subs]
               [re-frame.core :as re-frame]
               [reagent.core :as reagent]))

(def handle-save-sections
  (fn [payload] 
    (re-frame/dispatch [::section/save-sections payload])))

(defn index []
  (reagent/with-let [_ (do (re-frame/dispatch [::section/fetch-settings-fields])
                           (re-frame/dispatch [::events/fetch-sections true]))]
    (let [current-params (router/get-current-query-params)
          entity (:entity current-params)
          project-id @(re-frame/subscribe [::subs/current-project-id])
          groups @(re-frame/subscribe [::subs/groups])
          handle-entity-change (fn [new-entity]
                                 (router/update-query-params! assoc :entity new-entity))
          all-entities-field-data @(re-frame/subscribe [::subs/all-entity-fields])
          integrated-fields @(re-frame/subscribe [::subs/integrated-fields]) 
          all-entities-available-fields-data @(re-frame/subscribe [::subs/settings-fields])
          all-entity-sections @(re-frame/subscribe [::subs/all-entity-sections])
          test-case-versioning-enabled? @(re-frame/subscribe [::subs/test-case-versioning-enabled?])]
      (cond
        ;; Loading state when any required data is not ready
        (or (nil? all-entities-available-fields-data)
            (empty? entity)
            (empty? groups)
            (nil? all-entity-sections)
            (nil? all-entities-field-data)
            (empty? all-entity-sections)) 
        [:div {:class "centered-spinner"}
         [mux-spinner]]

        ;; Render FormLayoutWrapper only when all required data is ready
        :else
        [:> TranslationProvider
         [:> FormLayoutWrapper {:entity entity
                                :allEntitiesAvailableFieldsData all-entities-available-fields-data
                                :projectId project-id
                                :allEntitiesFieldData all-entities-field-data
                                :integratedFields integrated-fields
                                :handleSave #(handle-save-sections (js->clj % :keywordize-keys true))
                                :allEntitiesSectionData (clj->js all-entity-sections)
                                :handleEntityChange handle-entity-change
                                :testCaseVersioningEnabled test-case-versioning-enabled?}]]))))
   
